export var VIEW_MODES;
(function (VIEW_MODES) {
    VIEW_MODES["SITE"] = "site";
    VIEW_MODES["EDITOR"] = "editor";
    VIEW_MODES["PREVIEW"] = "preview";
    VIEW_MODES["DASHBOARD"] = "dashboard";
    VIEW_MODES["STANDALONE"] = "standalone";
})(VIEW_MODES || (VIEW_MODES = {}));
//# sourceMappingURL=view-modes.js.map